import { useApp } from "../../store";

export default function LocationSelector() {
  const { addresses } = useApp();
  const address = addresses.find((item) => item.default) || addresses[0];
  const label = address ? `${address.area || address.city || "Saved address"}, ${address.city || "Pune"}` : "Add your address";

  return (
    <button className="location-button" data-bs-toggle="modal" data-bs-target="#locationModal">
      <span><i className="fa-solid fa-location-dot" /></span>
      <span><small>Delivering to</small><strong>{label}</strong></span>
      <i className="fa-solid fa-chevron-down ms-1" />
    </button>
  );
}
